import Footer from '../../components/footer/Footer'
import Menu from '../../components/menu/menu'
import classes from './aboutUs.module.scss'
import { HiLightBulb } from "react-icons/hi";
import { GiGraduateCap } from "react-icons/gi";
import { MdOutlineSignalCellularAlt } from "react-icons/md";
import { BsStars } from "react-icons/bs";




export default function AboutUs() {
  return (
    <div className={classes.module}>
      <div className={classes.header}>
        <Menu />
      </div>
      <div className={classes.content}>
        <div className={classes.intro}>
          <div className={classes.desc}>
            <span className={classes.title}> The Story Behind Tx-Genius</span>
            <span className={classes.text}>Innovation in Implant and Smile Design</span>
            <span className={classes.text}>Transforming smiles with AI precision - advancing the future of digital dentistry</span>
            <span className={classes.text}>Join the Future of Dentistry</span>
          </div>
          <img src="/images/aboutus-banner.png" alt="The Story Behind Tx-Genius" />
        </div>

        <div className={classes.story}>
          <img src="/images/solutions-template-2.png" alt=" Where Innovation Meets Expertise" />
          <div className={classes.desc}>
            <span className={classes.title}> Where Innovation Meets Expertise</span>
            <span className={classes.text}>Tx-Genius is a product of Implant Genius, a Canadian tech company founded in 2018. It all began when Dr. Kevin Aminzadeh, a prosthodontist, recognized that patient outcomes could dramatically improve if prosthodontists played a central role in implant planning.</span>
            <span className={classes.text}>This led him to establish the world's first implant planning company where board- certified specialists determine the optimal placement of dental implants.</span>
          </div>
        </div>

        <div className={classes.journey}>
          <span className={classes.title}>Our Journey of Innovation</span>
          <div className={classes.items}>
            <div className={classes.item}>
              <h1>2018</h1>
              <HiLightBulb size={35} />
              <span className={classes.detail}>Founded in Canada as Implant Genius</span>
                          <span className={classes.desc}>Implant Genius, founded in 2018 in Vancouver, Canada, is a prosthodontist-led dental implant planning company. It leverages CT scans, digital technology, and custom surgical guides for precision. With the Tx-Genius platform and a mobile app, it enhances treatment planning and patient outcomes globally, supported by an in-house digital lab..</span>

            </div>
            <div className={classes.item}>
              <h1>2021</h1>
              <GiGraduateCap size={35} />
              <span className={classes.detail}>Inducted into Creative Destruction Lab</span>
              <span className={classes.desc}>In 2021, Implant Genius was inducted into the Creative Destruction Lab, setting the
                stage for Tx-Genius—an AI-powered platform designed to diagnose and create
                treatment plans based on a patient’s age, gender, and ethnicity.</span>

            </div>
            <div className={classes.item}>
              <h1>2024</h1>
              <MdOutlineSignalCellularAlt size={35} />
              <span className={classes.detail}>100-surgery trial success & App Launch</span>
              <span className={classes.desc}>By 2024, Tx-Genius successfully completed a 100-surgery trial in collaboration with
                Nobel Biocare, demonstrating its impact on predictable implant success. That same
                year, we launched our 2D and 3D image collection app on the App Store, allowing
                clinicians to seamlessly capture patient data and standardize thousands of datasets,
                further refining our AI-driven approach.</span>
            </div>
            <div className={classes.item}>
              <h1>2025</h1>
              <BsStars size={35} />
              <span className={classes.detail}>AI-driven smile design platform launch</span>
              <span className={classes.desc}>In 2025, Tx-Genius revolutionized digital dentistry further by launching its AI-driven smile design and printing platform in partnership with Sprintray, bringing rapid, patient-specific smile transformations to clinicians worldwide.</span>
            </div>
          </div>
        </div>

        <div className={classes.team}>
          <div className={classes.title}>
            <h1>OUR TEAM</h1>
            <img src="/images/triangle.svg" />
          </div>

          <div className={classes.member1}>
            <img src="/images/kevin-aminzadeh.jpg" alt="Team Member" width={300} />
            <div className={classes.info}>
              <span className={classes.name}>Dr. Kevin Aminzadeh</span><br />
              <span className={classes.degree}>CEO ,Prosthodontist, DDS</span>
              <p>More than 20 years of experience in treatment planning and digital smile design</p>
            </div>
          </div>

          <div className={classes.member2}>
            <div className={classes.info}>
              <span className={classes.name}>Isabell Taba</span><br />
              <span className={classes.degree}>MBA ,CSO</span>
              <p>15 years of experience in experience and a progressive approach to business growth, strategy, development</p>
            </div>
            <img src="/images/isabell-taba.jpg" alt="Team Member" width={300} />
          </div>


          <div className={classes.member1}>
            <img src="/images/Arash.jpg" alt="Team Member" width={300} />
            <div className={classes.info}>
              <span className={classes.name}>Arash Agahi</span><br />
              <span className={classes.degree}>Head of Product</span>
                          <p>Enterprise IT Transformation Leader: Boosting Competitiveness and Efficiency</p>
            </div>
          </div>
        </div>

      </div>

      <Footer />
    </div >
  )
}
